import CircularProgress from '@material-ui/core/CircularProgress';
import { Body } from '@minna-technologies/minna-ui/components/Typography/Body';
import type { FC, ReactNode } from 'react';
import React from 'react';
import styles from './styles.scss';

interface LoadingPageProps {
  caption?: ReactNode;
}

export const LoadingPage: FC<LoadingPageProps> = ({ caption }) => {
  return (
    <div className={styles['progress-container']} data-test="loading-page-div">
      <CircularProgress />
      {caption && (
        <div className={styles.caption}>
          <Body>{caption}</Body>
        </div>
      )}
    </div>
  );
};
